
export interface Image {
  url: string,
  isOnline: boolean,
  content: string,
  isSelected: boolean,
  isChecked: boolean,
  isDirty: boolean,
  thumbUrl: string,
  thumbAmazonId: string,
  bucketName: string,
  description: string,
  filename: string,
  amazonKey: string,
  documentType: string,
  documentStatus: string,
  createdOn: string;
  createdByFirstName: string,
  createdByLastName: string,
  id: number,
  amazonId: string,
  subjectLine: string,
  reportStatusTC: string,
  isForPreview: boolean,
  mimeType: string,
  approved?: boolean,
  VirusDetected?: boolean,
  AVScanned?: boolean,
  hasBeenQueued: boolean,
}
export function createImage() {
  const image: Image = {
    createdOn: '',
    description: '',
    documentStatus: '',
    documentType: '',
    filename: '',
    isOnline: false,
    url: '',
    amazonKey: '',
    bucketName: '',
    id: 0,
    amazonId: '',
    isChecked: false,
    thumbAmazonId: '',
    thumbUrl: '',
    content: '',
    isSelected: false,
    isDirty: false,
    createdByFirstName: '',
    createdByLastName: '',
    subjectLine: '',
    reportStatusTC: '',
    isForPreview: false,
    mimeType: '',
    hasBeenQueued: false,
  } 

  return image;
}

export class ImageIsDirtyRequest {
  id!: number;
  isDirty!: boolean;
}
